<template>
  <div>
    <div class="px-6">
      <v-container class="px-0">
        <v-row
          class=""
          :class="`${
            $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
          }`"
        >
          <v-col
            class="d-flex justify-space-between align-center flex-lg-row flex-row"
            :class="[
              $vuetify.breakpoint.lgAndDown ? 'mt-3 mb-3' : 'mt-7 mb-7',
              $vuetify.breakpoint.xsAndDown ? 'flex-column' : 'flex-row',
            ]"
          >
            <div
              class="w-100 d-flex align-center justify-space-between top-title"
            >
              <h1 class="font-weight-800">
                {{ $t("general.myPlans") }}
              </h1>
            </div>
          </v-col>
          <v-col
            class="page-title__filter-controls justify-end align-center"
            :class="[`${$vuetify.breakpoint.mobile ? 'pb-3' : ''}`]"
          >
            <data-iterator-filter-controls
              :showSearchTerm="true"
              :searchTerm="searchTerm"
              @update:searchTerm="handleSearchTermChange"
              @update:sortBy="changeSortBy"
              @update:sortDesc="handleSortDescChange"
            ></data-iterator-filter-controls>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-divider
      :class="$vuetify.breakpoint.lgAndDown ? 'mb-3' : 'mb-10'"
    ></v-divider>

    <div class="px-6">
      <v-container class="p0-0">
        <v-row>
          <v-col>
            <ServicesTable
              :services="services"
              :loading="loading"
              :itemsPerPage="itemsPerPage"
              :page="page"
              :possibleItemsPerPage="[[10, 20, 30]]"
              :searchTerm="searchTerm"
              :sortBy="sortBy"
              :sortDesc="sortDesc"
              @update:searchTerm="handleSearchTermChange"
              @update:check-all="handleSelectAll"
              @update:checked-items="handleItemCheck"
              @update:itemsPerPage="changePerPage"
              @update:page="changePage"
              @update:sortBy="changeSortBy"
              @update:sortDesc="changeSortDesc"
              @service-cancelled="loadServices"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import Api from "@/apis/Api";
import ServicesTable from "../components/dataIterator/tables/ServicesTable.vue";
import DataIteratorPageMixin from "../mixins/DataIteratorPageMixin";
import CustomTablePageMixin from "../mixins/CustomTablePageMixin";
import DataIteratorFilterControls from "../components/dataIterator/DataIteratorFilterControls.vue";

export default {
  components: {
    ServicesTable,
    DataIteratorFilterControls,
  },
  mixins: [DataIteratorPageMixin, CustomTablePageMixin],
  mounted() {
    if (!this.billingEnabled) {
      this.$router.push({ path: "/instances" });
      return;
    }
    this.loadServices();
  },
  data() {
    return {
      loading: false,
      services: [],
      sortBy: {
        text: "plan_name",
        align: "start",
        value: "plan_name",
        sortable: true,
      },
      checkedItems: [],
      allItems: [],
      page: 1,
      itemsPerPage: 10,
      searchTerm: "",
      itemsTotal: 0,
    };
  },
  computed: {
    billingEnabled() {
      if (this.$store.state.home?.app?.billing_enabled) {
        return true;
      }
      return false;
    },
  },
  methods: {
    loadServices() {
      this.loading = true;
      Api.get("/services")
        .then((response) => {
          this.services = response.data.data.map((service) => {
            let instancesCount = 0;
            for (let instance of service.instances) {
              if (!instance.parent_id) {
                instancesCount++;
              }
            }
            service.instances_count = instancesCount;
            return service;
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      this.page = page;
      this.loadServices();
    },
    changePerPage(perPage) {
      this.page = 1;
      this.itemsPerPage = perPage;
      this.loadServices();
    },
    changeSortBy: function (data) {
      this.page = 1;
      this.sortBy = data;
      this.loadServices();
    },
    changeSortDesc: function (data) {
      this.page = 1;
      this.sortDesc = data;
      this.loadServices();
    },
    handleSearchTermChange: function (newValue) {
      this.page = 1;
      this.searchTerm = newValue;
      this.loadServices();
    },
  },
};
</script>
